module.exports = __webpack_public_path__ + "img/toyota-prado.9065f54b.png";